/* unplugin-vue-components disabled */import script from "./MatchEvaluationAfter.vue?vue&type=script&lang=ts&setup=true"
export * from "./MatchEvaluationAfter.vue?vue&type=script&lang=ts&setup=true"

const __exports__ = script;

export default __exports__